/* eslint-disable prefer-destructuring */
<template>
  <div class="popUp-box">
    <el-form
      ref="ruleForm"
      :model="fromData"
      :rules="rules"
      label-width="130px"
      class="demo-ruleForm"
    >
      <div class="client-info">
        <span class="title">客户信息</span>
        <div class="content">
          <el-form-item
            label="租客名称:"
            :prop="DomState?'tenantName':''"
          >
            <el-select
              v-show="DomState"
              v-model="fromData.tenantName"
              filterable
              remote
              reserve-keyword
              placeholder="请输入租客名称"
              :remote-method="remoteMethod"
              :loading="loading"
              :disabled="disabled"
              @change="valChange"
            >
              <el-option
                v-for="item in restaurants"
                :key="item.tenantId"
                :label="item.tenantName"
                :value="item.tenantId"
                style="width:200px"
              >
                <span>{{ item.tenantName }}</span>
                <span class="tenantId">({{ item.tenantId }})</span>
              </el-option>
            </el-select>

            <span v-show="!DomState">{{ fromData.tenantName }}</span>
          </el-form-item>
          <el-form-item
            label="客户名称:"
            :prop="DomState?'customerName':''"
          >
            <el-select
              v-show="DomState"
              v-model="fromData.customerName"
              filterable
              remote
              reserve-keyword
              clearable
              placeholder="请输入客户名称"
              :remote-method="remoteMethod1"
              :loading="loading"
              @change="valChange1"
            >
              <el-option
                v-for="item in restaurants1"
                :key="item.id"
                :label="item.customerName"
                :value="item.customerCode"
                style="width:200px"
              >
                <span>{{ item.customerName }}</span>
              </el-option>
            </el-select>

            <span v-show="!DomState">{{ fromData.customerName }}</span>
          </el-form-item>
        </div>
        <div class="content">
          <el-form-item
            label="客户站点编码:"
            :prop="DomState?'customerStationCode':''"
          >
            <el-input
              v-show="DomState"
              v-model="fromData.customerStationCode"
              placeholder="请输入站点名称"
            />
            <span v-show="!DomState">{{ fromData.customerStationCode }}</span>
          </el-form-item>
          <el-form-item
            label="状态:"
            class="state"
            :prop="DomState?'status':''"
          >
            <el-radio-group v-show="DomState" v-model="fromData.status">
              <el-radio v-model="fromData.status" label="DISABLED">
                停用
              </el-radio>
              <el-radio v-model="fromData.status" label="ENABLED">
                启用
              </el-radio>
            </el-radio-group>
            <span v-show="!DomState">{{ fromData.status==='ENABLED'?'启用':'停用' }}</span>
          </el-form-item>
        </div>
      </div>
      <div class="client-info">
        <span class="title">站点信息</span>
        <div class="content">
          <el-form-item
            label="站点名称:"
            :prop="DomState?'stationName':''"
          >
            <el-input
              v-show="DomState"
              v-model="fromData.stationName"
              placeholder="请输入站点名称"
            />
            <span v-show="!DomState">{{ fromData.stationName }}</span>
          </el-form-item>
          <el-form-item
            label="站点类型:"
            :prop="DomState?'bizType':''"
          >
            <el-select
              v-if="DomState"
              v-model="fromData.bizType"
              :disabled="!bizTypeIsShow"
              placeholder="请选择站点类型"
            >
              <el-option
                v-for="item in bizTypeOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              />
            </el-select>
            <span v-show="!DomState">{{ SiteTypesInfo[fromData.bizType] }}</span>
          </el-form-item>
        </div>
        <div class="content">
          <el-form-item
            label="运输分类:"
            :prop="DomState?'stationType':''"
          >
            <el-select
              v-if="DomState"
              v-model="fromData.stationType"
              placeholder="请选择运输分类"
            >
              <el-option
                v-for="item in stationTypeOption"
                :key="item.value"
                :label="item.label"
                :value="Number(item.value)"
                :disabled="item.disabled"
              />
            </el-select>
            <span v-show="!DomState">{{ SitetSationType[fromData.stationType] }}</span>
          </el-form-item>
          <el-form-item
            label="业态类型:"
            prop="type"
          >
            <el-select
              v-if="DomState"
              v-model="fromData.type"
              placeholder="请选择业态类型"
            >
              <el-option
                v-for="item in typeOption"
                :key="item.value"
                :label="item.label"
                :value="Number(item.value)"
                :disabled="item.disabled"
              />
            </el-select>
            <span v-show="!DomState">{{ SiteCommercialtype[fromData.type] }}</span>
          </el-form-item>
        </div>
        <div class="content">
          <el-form-item
            label="站点类别:"
            prop="stationCategory"
          >
            <el-select
              v-if="DomState"
              v-model="fromData.stationCategory"
              placeholder="请选择站点类别"
            >
              <el-option
                v-for="item in stationCategoryOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              />
            </el-select>
            <span v-show="!DomState">{{ stationCategory[fromData.stationCategory] }}</span>
          </el-form-item>
          <el-form-item
            label="关联的WMS仓库:"
            prop="houseTenantId"
          >
            <el-input
              v-show="DomState"
              v-model="wmsTenantId"
              placeholder="请输入关联的WMS仓库"
            />
            <span v-show="!DomState">{{ wmsTenantId }}</span>
          </el-form-item>
        </div>
        <div class="content">
          <el-form-item
            label="服务时长:"
            prop="serviceDuration"
          >
            <el-input
              v-show="DomState"
              v-model="fromData.serviceDuration"
              placeholder="请输入服务时长"
            />
            <span v-show="!DomState">{{ fromData.serviceDuration }}</span>
          </el-form-item>
          <el-form-item
            label="首选线路标识:"
            prop="preLineIdent"
          >
            <el-input
              v-show="DomState"
              v-model="fromData.preLineIdent"
              placeholder="请输入首选线路标识"
            />
            <span v-show="!DomState">{{ fromData.preLineIdent }}</span>
          </el-form-item>
        </div>
        <div class="content">
          <el-form-item
            label="标记统一站点:"
            class="lang-item"
            :prop="DomState?'provinceCode':''"
          >
            <el-cascader
              v-if="DomState"
              v-model="checkCityCode"
              :options="options"
              :props="{label:'areaName',value:'areaCode'}"
              placeholder="请选择地址"
              @change="handleChange"
            />
            <span v-show="!DomState">{{ addressShow() }}</span>
            <div class="search-box">
              <el-input
                v-show="DomState"
                v-model="fromData.address"
                class="address-search"
                style="z-index:3333;"
                placeholder="请输入详细地址"
              />
              <span v-show="!DomState" class="address-text">{{ fromData.address }}</span>
              <el-tooltip content="注意：该地址用于像是在订单和运单的详细地址中" placement="top">
                <i class="el-icon-question" />
              </el-tooltip>
              <el-button
                v-show="DomState"
                type="primary"
                style="line-height:10px;margin-left:10px;"
                @click="searchBtn()"
              >
                匹配经纬度
              </el-button>
              <el-select
                v-if="DomState"
                id="addSelect"
                ref="addSelect"
                class="addSelect"
                :popper-class="visible ? '' : 'addrselectVisible'"
                :value="fromData.address"
                no-match-text=" "
                :popper-append-to-body="false"
                filterable
                placeholder="请选择"
                style="position:absolute;left:0px;top:0px;z-index:332"
                @input="addrChange"
                @keyup.native.prevent="addrKeyup"
              >
                <el-option
                  v-for="(item, index) in poiInfo"
                  :key="index"
                  class="optionItme"
                  :label="item.name"
                  :value="item.name"
                >
                  <span class="name">
                    {{ item.name }}
                  </span>
                  <span :title="item.address" class="address overellipsis">
                    {{ item.address }}
                  </span>
                  <span class="type">
                    {{ item.typeLev3 }}
                  </span>
                </el-option>
                <el-option
                  key="9527"
                  class="addressOptionLast"
                  label="没有要找的地址？点这里"
                  value=" "
                />
              </el-select>
            </div>
          </el-form-item>
        </div>
        <div v-if="choosePoinInfo && choosePoinInfo.address && DomState" class="alert-info">
          <div class="color-warning">
            匹配结果：
          </div>
          <div class="desc">
            {{ choosePoinInfo.address }}
            {{ choosePoinInfo.name }}
          </div>
          <el-button
            type="text"
            class="btn-left"
            @click="handleInputPoint"
          >
            填入详细地址输入框中
          </el-button>
        </div>
      </div>
      <div class="popUp-map">
        <Map @positionYx="positionInfo" />
      </div>
      <div class="client-info">
        <div class="content">
          <el-form-item
            label="站点地址:"
            class="lang-item"
            :prop="DomState?'provinceCode':''"
          >
            <el-cascader
              v-if="DomState"
              v-model="checkCityCode"
              :options="options"
              :props="{label:'areaName',value:'areaCode'}"
              @change="handleChange"
            />
            <span v-show="!DomState">{{ addressShow() }}</span>
            <el-input
              v-show="DomState"
              v-model="fromData.address"
              class="address-inp"
              placeholder="请输入站点名称"
            />
            <span v-show="!DomState" class="address-inp">{{ fromData.address }}</span>
          </el-form-item>
        </div>
        <span class="tips">该数据，将用于OMS下单、运单/司机端站点地址展示</span>
      </div>
      <div class="client-info">
        <span class="title">附件信息</span>
        <div class="content">
          <el-form-item
            label="联系人:"
            :prop="DomState?'contacts':''"
          >
            <el-input
              v-show="DomState"
              v-model="fromData.contacts"
              placeholder="请输入联系人"
            />
            <span v-show="!DomState">{{ fromData.contacts }}</span>
          </el-form-item>
          <el-form-item
            label="联系电话:"
            :prop="DomState?'telPhone':''"
          >
            <el-input
              v-show="DomState"
              v-model="fromData.telPhone"
              placeholder="请输入联系电话"
            />
            <span v-show="!DomState">{{ fromData.telPhone }}</span>
          </el-form-item>
        </div>
      </div>
      <div>
        <el-table
          :data="tableData"
          border
          style="width: 100%"
        >
          <el-table-column
            align="center"
            label="收货人姓名"
          >
            <template slot-scope="scope">
              <el-input
                v-show="DomState"
                v-model="scope.row.propertyValue"
                placeholder="请输入收货人姓名"
              />
              <span v-show="!DomState">{{ scope.row.propertyValue }}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="收货人手机号码"
          >
            <template slot-scope="scope">
              <!-- <el-from-item
                :rules="rule"
                :prop="scope.row.tel"
              >
                <el-input
                  v-show="DomState"
                  v-model="scope.row.tel"
                  class="tel-input"
                  placeholder="请输入收货人手机号码"
                />
                <span v-show="!DomState">{{ scope.row.tel }}</span>
              </el-from-item> -->
              <el-input
                v-show="DomState"
                v-model="scope.row.propertyKey"
                class="tel-input"
                placeholder="请输入收货人手机号码"
                :validate-event="true"
              />
              <span v-show="!DomState">{{ scope.row.propertyKey }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="DomState"
            width="100"
            align="center"
            label="操作"
          >
            <template slot-scope="scope">
              <span
                v-show="DomState"
                class="deleteBtn"
                @click="deleteLinkman(scope.row)"
              >删除</span>
            </template>
          </el-table-column>
        </el-table>
        <span
          v-show="DomState"
          class="addLine"
          @click="addLine()"
        >+添加行</span>
      </div>
    </el-form>
  </div>
</template>

<script>
import {
  getPoiList, gettenantName, getSiteList, getcustomerName, selectCityAreaTree,
} from '@/api/siteManagement';
import { processingSelectData } from '@/utils/index';
import {
  SiteTypesInfo, SitetSationType, SiteCommercialtype, stationCategory,
} from '../const';
import Map from './map.vue';
import Bus from '../bus';

export default {
  components: {
    Map,
  },
  data() {
    return {
      SiteTypesInfo,
      SitetSationType,
      SiteCommercialtype,
      stationCategory,
      fromData: {
        tags: '11',
        id: null, // id编辑需要传
        tenantName: null, // 租客名称
        tenantId: null,
        customerName: null, // 客户名称
        customerCode: null,
        customerId: null,
        status: null, // 是否启用
        stationName: null, // 站点名称
        customerStationCode: null, // 客户站点code
        contacts: null, // 联系人
        telPhone: null, // 联系电话
        create_user: null, // 创建人
        bizType: null, // 站点类型
        houseTenantId: null, // 关联仓库id
        cityCode: null, // 城市code
        countyCode: null, // 区code
        provinceCode: null, // 省code
        latitude: null, // 纬度
        longitude: null, // 经度
        preLineIdent: null, // 首选线路标识
        source: null, // 数据来源
        type: null, // 业态类型
        poiId: null,
        // create_user: null, // 创建人
        stationType: null, // 运输分类
        stationCategory: null, // 站点类别
        address: null, // 详细地址
        provinceName: null, // 省名
        cityName: null, // 城市名
        countyName: null, // 区县名
        poiExt: null, // 大数据提供的地址信息
        ext: null, // 额外信息
        updateTime: null, // 上传时间
        serviceDuration: null, // 服务时长
      },
      rules: {
        tenantName: [
          {
            required: true, message: '请输入租客名称', trigger: 'blur',
          },
        ],
        customerStationCode: [
          {
            required: false, message: '请输入租客名称', trigger: 'blur',
          },
          { pattern: /^[\da-zA-Z@#$%^&*-_./]*$/, message: '只允许输入数字和字母和特殊字符@#$%^&*-_./' },
        ],
        status: [
          {
            required: true, message: '请选择站点状态', trigger: 'blur',
          },
        ],
        stationName: [

          {
            required: true, message: '请输入站点名称', trigger: 'blur',
          },
        ],
        bizType: [
          {
            required: true, message: '请选择站点类型', trigger: 'blur',
          },
        ],
        stationType: [
          { required: true, message: '请选择运输分类', trigger: 'blur' },
        ],
        provinceCode: [
          { required: true, message: '请标记统一站点', trigger: 'blur' },
        ],
        contacts: [
          { required: true, message: '请输入联系人', trigger: 'blur' },
        ],
        telPhone: [
          { required: true, message: '请输入联系人电话', trigger: 'blur' },
          { pattern: /^1[34578]\d{9}$/, message: '请输入正确的手机号码' },
        ],
        serviceDuration: [
          { required: false, message: '请输入服务时长', trigger: 'blur' },
          { pattern: /^[0-9]*$/, message: '请输入正确服务时长' },
        ],
      },
      rule: { pattern: /^1[34578]\d{9}$/, message: '请输入正确的手机号码' },
      options: [],
      checkCityCode: null,
      handleSelect: [],
      // 业态类型
      tableData: [],
      DomState: true, // 改变标签
      siteInfo: {
        address: '',
        detailedAddress: '',
        position: '',
      },
      visible: false,
      poiInfo: [],
      isEnit: false,
      restaurants: [], // 租客
      loading: false,
      restaurants1: [], // 客户
      flagText: null,
      bizTypeIsShow: true, // 站点类型因为数据跨端原因现先禁用,待后端处理完后开启
      wmsTenantId: '',
      choosePoinInfo: {}, // 选择的地址信息
    };
  },
  computed: {
    bizTypeOption() {
      return processingSelectData(SiteTypesInfo).map((v) => {
        if (v.label === '仓库站点') {
          return {
            ...v,
            disabled: true,
          };
        }
        return { ...v };
      });
    },
    typeOption() {
      return [
        ...processingSelectData(SiteCommercialtype),
      ];
    },
    stationTypeOption() {
      return [
        ...processingSelectData(SitetSationType),
      ];
    },
    stationCategoryOption() {
      return [
        ...processingSelectData(stationCategory),
      ];
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    'fromData.latitude': function (newval, old) {
      if (!newval) {
        this.fromData.latitude = old;
      }
    },
    // eslint-disable-next-line func-names
    'fromData.longitude': function (newval, old) {
      if (!newval) {
        this.fromData.longitude = old;
      }
    },
  },
  mounted() {
    this.fromData.status = 'ENABLED';
  },
  created() {
    this.choosePoinInfo = {};
    this.disabled = false;
    this.bizTypeIsShow = true;
    this.getCityCode();
    Bus.$on('examineState', this.state);
    Bus.$on('viewSiteDetail', this.viewSiteDetailInfo);
    Bus.$on('flag', this.saveData);
    Bus.$on('newAdd', this.newAddSite);
  },
  destroyed() {
    Bus.$off('examineState');
    Bus.$off('viewSiteDetail');
    Bus.$off('flag');
    Bus.$off('newAdd');
    this.DomState = true;
  },
  methods: {
    async getCityCode() {
      const res = await selectCityAreaTree({});
      this.options = this.cityTreeDataTreating(res);
    },
    cityTreeDataTreating(data) {
      return data.map((v) => {
        if (v.children && v.children.length) {
          this.cityTreeDataTreating(v.children);
        } else if (v.children && !v.children.length) {
          // eslint-disable-next-line no-param-reassign
          delete v.children;
        }
        return v;
      });
    },
    addressShow() {
      if (this.fromData.poiExt) {
        return (this.fromData.poiExt.province || this.fromData.poiExt.provinceName) + (this.fromData.poiExt.city || this.fromData.poiExt.cityName) + (this.fromData.poiExt.county || this.fromData.poiExt.countyName);
      }
      return '';
    },
    valChange(val) {
      this.fromData.tenantId = val;
      const res = this.restaurants.filter((v) => v.tenantId === val)[0];
      this.fromData.tenantName = res.tenantName;
    },
    valChange1(val) {
      if (!val) return;
      this.fromData.customerCode = val;
      const res = this.restaurants1.filter((v) => v.customerCode === val)[0];
      this.fromData.customerId = res.id;
      this.fromData.customerName = res.customerName;
    },
    remoteMethod(query) {
      this.restaurants = [];
      if (query !== '') {
        this.loading = true;
        gettenantName({ tenantName: query }).then((res) => {
          this.loading = false;
          this.restaurants = res.records;
        });
      } else {
        this.restaurants = [];
      }
    },
    remoteMethod1(query) {
      if (query !== '') {
        this.loading = true;
        getcustomerName({ customerName: query, ownerTenantId: this.fromData.tenantId }).then((res) => {
          this.loading = false;
          this.restaurants1 = res.records;
        });
      } else {
        this.restaurants1 = [];
      }
    },
    newAddSite(e) {
      this.bizTypeIsShow = true;
      this.fromData.status = 'ENABLED';
      this.poiInfo = [];
      this.disabled = false;
      this.flagText = e;
      this.DomState = true;
      this.fromData = {
        tags: '11',
        tenantName: null, // 租客名称
        tenantId: null,
        properties: null, // 收货人信息
        customerId: null,
        customerName: null, // 客户名称
        customerCode: null,
        status: 'ENABLED', // 是否启用
        stationName: null, // 站点名称
        customerStationCode: null, // 客户站点code
        contacts: null, // 联系人
        telPhone: null, // 联系电话
        bizType: null, // 站点类型
        houseTenantId: null, // 关联仓库id
        cityCode: null, // 城市code
        countyCode: null, // 区code
        provinceCode: null, // 省code
        latitude: null, // 纬度
        longitude: null, // 经度
        preLineIdent: null, // 首选线路标识
        source: null, // 数据来源
        type: null, // 业态类型
        poiId: null,
        create_user: null, // 创建人
        stationType: null, // 运输分类
        stationCategory: null, // 站点类别
        address: null, // 详细地址
        provinceName: null, // 省名
        cityName: null, // 城市名
        countyName: null, // 区县名
        poiExt: null, // 大数据提供的地址信息
        ext: null, // 额外信息
        updateTime: null, // 上传时间
        serviceDuration: null, // 服务时长
      };
      this.checkCityCode = null;
      this.tableData = [];
    },
    saveData() {
      if (this.newPosition) {
        this.fromData.latitude = this.newPosition.latitude;
        this.fromData.longitude = this.newPosition.longitude;
      }
      const time = new Date().getTime();
      const userName = JSON.parse(localStorage.userInfo);
      this.fromData.create_user = userName.userId;
      this.fromData.updateTime = time;
      if (!this.fromData.poiId && !this.choosePoinInfo.id) {
        this.$message('请搜索一个统一站点并选择后，再保存!');
        return;
      }
      const poiExt = this.choosePoinInfo || this.fromData.poiExt;
      const data = {
        ...this.fromData,
        poiId: this.choosePoinInfo.id || this.fromData.poiId,
        poiExt,
        cityCode: poiExt.cityCode, // 城市code 1
        countyCode: poiExt.countyCode, // 区code 1
        provinceCode: poiExt.provinceCode, // 省code 1
      };
      data.properties = this.tableData;
      if (this.wmsTenantId) {
        data.ext = {
          wmsTenantId: this.wmsTenantId,
        };
      }
      // eslint-disable-next-line consistent-return
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$emit('save', data);
        } else {
          return false;
        }
      });
    },
    async state(e) {
      this.bizTypeIsShow = false;
      this.choosePoinInfo = {};
      const res = await getSiteList({ ids: [e.id] });
      this.rules = {
        tenantName: [
          {
            required: true, message: '请输入租客名称', trigger: 'blur',
          },
        ],
        customerStationCode: [
          {
            required: false, message: '请输入租客名称', trigger: 'blur',
          },
          { pattern: /^[\da-zA-Z@#$%^&*-_./]*$/, message: '只允许输入数字和字母和特殊字符@#$%^&*-_./' },
        ],
        status: [
          {
            required: true, message: '请选择站点状态', trigger: 'blur',
          },
        ],
        stationName: [

          {
            required: true, message: '请输入站点名称', trigger: 'blur',
          },
        ],
        bizType: [
          {
            required: true, message: '请选择站点类型', trigger: 'blur',
          },
        ],
        stationType: [
          { required: true, message: '请选择运输分类', trigger: 'blur' },
        ],
        provinceCode: [
          { required: true, message: '请标记统一站点', trigger: 'blur' },
        ],
        contacts: [
          { required: true, message: '请输入联系人', trigger: 'blur' },
        ],
        telPhone: [
          { required: true, message: '请输入联系人电话', trigger: 'blur' },
          { pattern: /^1[34578]\d{9}$/, message: '请输入正确的手机号码' },
        ],
        serviceDuration: [
          { required: false, message: '请输入服务时长', trigger: 'blur' },
          { pattern: /^[0-9]*$/, message: '请输入正确服务时长' },
        ],
      };
      this.DomState = true;
      this.disabled = true;
      this.renderData(res[0]);
    },
    async viewSiteDetailInfo(e) {
      this.choosePoinInfo = {};
      const res = await getSiteList({ ids: [e.id] });
      this.DomState = false;
      this.renderData(res[0]);
    },
    handleChange(e) {
      /*eslint-disable */
      this.fromData.provinceCode = e[0];
      this.fromData.cityCode = e[1];
      this.fromData.countyCode = e[2];
      const address = this.getAddressInfo(e);
      this.fromData.provinceName = address[0];
      this.fromData.cityName = address[1];
      this.fromData.countyName = address[2];
      Bus.$emit('addressInfo', this.getAddressInfo(e));
    },
    deleteLinkman(row) {
      this.tableData.splice(this.tableData.indexOf(row), 1);
    },
    addLine() {
      this.tableData.push({
        propertyValue: '', propertyKey: '', propertyType: 'receipt',
      });
    },
    async searchBtn() {
      this.$refs.addSelect.focus();
      this.visible = true;
      const {
        provinceName, cityName, countyName, address,
      } = this.fromData;
      const PoiData = {
        address: provinceName + cityName + countyName + address || '',
        lon: '',
        lat: '',
        size: 12,
        radiusMeter: 3000,
      };
      const res = await getPoiList(PoiData);
      this.poiInfo = res;
    },
    addrChange(val) {
      const res = this.poiInfo.filter((v) => v.name === val)[0];
      this.newPosition = {
        latitude: res.lat,
        longitude: res.lon,
      };
      this.choosePoinInfo = res;
      // 这是让地图显示选择的地址信息
      Bus.$emit('poiInfo', res);
    },
    handleInputPoint() {
      // 将地址填入输入框
      const {
        id, provinceCode, cityCode, county, countyCode, name,
      } = this.choosePoinInfo;
      this.fromData.address = name;
      this.fromData.poiId = id;
      this.fromData.provinceCode = provinceCode;
      this.fromData.cityCode = cityCode;
      this.fromData.countyCode = countyCode;
      this.fromData.countyName = county
      this.fromData.poiExt = this.choosePoinInfo;
      this.checkCityCode = [provinceCode, cityCode, countyCode];
      Bus.$emit('poiInfo', this.choosePoinInfo);
    },
    addrKeyup() {
    },
    async positionInfo(e) {
     /* eslint-disable */
      let res = await getPoiList({
        lon: e.position.lng,
        lat: e.position.lat,
        size: 1,
        radiusMeter: 100,
      })
      let {
        address, id, lat, lon, cityCode, city, county, countyCode, province, provinceCode, typeLev3
      } = res[0]
      this.fromData.poiId=id;
      this.siteInfo = e;
      this.fromData.address = address;
      // 将省市区转为code码
      this.checkCityCode =[provinceCode,cityCode,countyCode];
      this.fromData.longitude = lon;
      this.fromData.latitude = lat;
      this.fromData.provinceCode = provinceCode;
      this.fromData.cityCode = cityCode;
      this.fromData.countyCode = countyCode;
      this.fromData.provinceName = province;
      this.fromData.cityName = city;
      this.fromData.countyName = county;
      this.fromData.poiExt=res[0]
      this.choosePoinInfo=res[0]
      Bus.$emit('poiType', typeLev3);
    },
    // 通过省市区code码获取具体地址
    getAddressInfo(res) {
      const address = [];
      this.options.map((item) => {
        if (item.areaCode === res[0]) {
          address.push(item.areaName);
          item.children.map((child) => {
            if (child.areaCode === res[1]) {
              address.push(child.areaName);
              child.children.map((v) => {
                if (v.areaCode === res[2]) {
                  address.push(v.areaName);
                }
              });
            }
          });
        }
      });
      return address;
    },
    getAreaCode(res) {
      const code = [];
      this.options.map((item) => {
        if (item.areaName === res[0]) {
          code.push(item.areaCode);
          item.children.map((child) => {
            if (child.areaName === res[1]) {
              code.push(child.areaCode);
              child.children.map((v) => {
                if (v.areaName === res[2]) {
                  code.push(v.areaCode);
                }
              });
            }
          });
        }
      });
      return code;
    },

    renderData(data) {
      this.fromData=data
      const {
         poiExt , ext,  cityCode, countyCode, provinceCode }=data
      if (poiExt) {
        if (!poiExt.provinceCode && !poiExt.cityCode && !poiExt.countyCode) {
          this.checkCityCode = [provinceCode, cityCode, countyCode];
        } else {
          this.checkCityCode = [poiExt.provinceCode, poiExt.cityCode, poiExt.countyCode];
        }
      } else {
        this.checkCityCode = [provinceCode, cityCode, countyCode];
      }
      if(ext){
        this.wmsTenantId=ext.wmsTenantId
      }
      this.choosePoinInfo = poiExt || {}
    },
  },
};
</script>

<style lang="scss" scoped>
.popUp-box{
  width: 100%;
  height: 90%;
}
.content{
  display: flex;
  flex: 1;
}
.title{
  font-size: 16px;
  font-weight: bold;
}

.popUp-lab{
  width: 50%;
  display: flex;
  align-items: center;
  margin-right: 30px;
}
.lab-text{
  white-space:nowrap;
  margin-right: 10px;
  width: 100px;
  text-align: right;
  }
  .popUp-lablang{
    width: 100%;
    display: flex;
    align-items: center;

  }

.popUp-box .el-input--small,.el-input--suffix{
  width: 200px !important;
}
.el-cascader,.el-select{
   width: 200px !important;
}
 .address-inp{
  margin-left: 100px;
}

.popUp-map{
  margin-left: 110px;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 10px;
}
.deleteBtn,.addLine{
  cursor: pointer;
  &:hover{
    color: #059E84;
  }
}
.addLine{
  line-height: 32px;
}
.tips{
  margin-left: 110px;
  color: #ccc;
}
 .el-popover{
  left: 100px !important;
}
.addrselectVisible {
    visibility: hidden;

  }
   .optionItme {
    span {
      float: left;
      margin-right: 5px;
    }
    .address {
      color: #8492a6;
      font-size: 13px;
    }
    .type {
      background: #00af66;
      font-size: 12px;
      border-radius: 3px;
      padding: 0 5px;
      margin-left: 5px;
      color: #fff;
      height: 18px;
      line-height: 18px;
      margin-top: 8px;
    }
  }
  .address-text{
    margin-left: 20px;
  }
.el-form-item .el-form-item__content .address-search{
   flex: 1;
}
.el-form-item .el-form-item__content .address-inp{
   flex: 1;
}
 .el-select-dropdown {
  min-width: 306px !important;
}
.el-form-item--small.el-form-item{
 flex: 1 !important;
}
.content .lang-item{
  width: 100% !important;
}
.el-radio-group{
  line-height: 32px;
  padding-top: 4px;
}
.tenantNameSele{
  position: absolute;
}
.tenantId{
  color: #ccc;
  font-size: 12px;
  margin-left: 10px;
}
.lang-item >>> .el-form-item__content {
  padding-right: 85px !important;
}
.search-box{
  position: relative;
  display: flex;
  width: 56%;
  margin-left: 20px;
  margin-bottom:10px;
}
.alert-info{
  display: flex;
  font-size:12px;
  margin-left:350px;
  align-items:center;
  display:flex;
  position:relative;
  top:-20px;
  .color-warning{
    color:#e6a23c;
  }
  .desc{
    max-width:calc(100% - 240px);
  }
  .btn-left{
    margin-left:20px;
    font-size:10px;
  }
}

.addSelect {
  border: 0;
  &:focus{
    color: #fff;
  }
}

.addSelect ::v-deep.el-select-dropdown {
  top: 479px !important;
  left: 590px !important;
}
.el-icon-question{
  font-size:20px;
  display:flex;
  align-items:center;
  margin-left:6px;
  cursor:pointer;
}
</style>
